<!-- eslint-disable -->
<template>
  <svg
    class="kc-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 250 250">
    <!-- Speech bubble -->
    <rect x="20" y="25" width="215" height="170" rx="25" ry="30"/>

    <!-- Tail -->
    <polyline points="110 165 80 195 85 165" transform="translate(-2,28.5)" />
  </svg>
</template>
